import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PublHomeData from "./PublHomeData";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { IoIosCart } from "react-icons/io";
import axios from "axios";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';

export default function PubUserSearch() {
  const location = useLocation();
  const searchData = location.state?.searchData;
  const navigate = useNavigate();
  const phoneNo = useSelector(state => state.pubLogin.userPhone);
  
  // Filter products based on searchData and exclude out of stock items
  const filteredProducts = PublHomeData.filter((product) => 
    product.name.toLowerCase().includes(searchData.search.toLowerCase()) && !product.outOfStock
  );

  const handleBack = () => {
    navigate("/publicUser");
  };

  const handleAddToCart = async (e, product) => {
    e.stopPropagation(); // Prevent the click event from propagating to the card click handler
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/checkCart`,
        { productName: product.name, customerPhone: phoneNo }
      );
  
      if (response.data.exists) {
        // Product is already in the cart, show info toast
        toast.info(`${product.name} is already in the cart. You can increase the quantity.`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true, 
          draggable: true,
          progress: undefined,
        });
      } else {
        // Product is not in the cart, proceed to add
        const newData = {
          productName: product.name,
          productWeight: product.weight,
          productPrice: product.price,
          customerPhone: phoneNo,
        };
  
        // Show a success notification
        toast.success(`${product.name} added to cart!`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
  
        // Make the axios request to add the item to the cart
        await axios.post(
          `${process.env.REACT_APP_API_URL}/pubCart`,
          newData
        );
      }
    } catch (error) {
      console.error("Error checking cart:", error.message);
      if (error.response) {
        console.error("Server responded with status:", error.response.status);
      }
    }
  };

  const handleClick = (product) => {
    navigate('/productPage', { state: { product } });
  };

  return (
    <div className="container">
      {filteredProducts.length === 0 ? (
        <div className="text-center">
          <h3>Product not found</h3>
          <button className="btn-primary btn-lg rounded-pill shadow" onClick={handleBack}>
            Go back
          </button>
        </div>
      ) : (
        <div className="row justify-content-center">
          {filteredProducts.map((product, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex justify-content-center" key={index}>
              <div className="card" onClick={() => handleClick(product)}>
                <img src={product.img} className="card-img-top" alt={product.name} />
                <div className="card-body">
                  <h4 className="card-title">{product.name}</h4>

                  <h4 className="card-text">
                    Price: <FaIndianRupeeSign />
                    {product.price}
                  </h4>
               <h6 className="card-text">Including GST, shipping & packaging</h6>
                                    <h5 style={{   
                                         fontSize: "1.08rem",
                                       color: "#444",
                                      fontWeight: "600",
                                      letterSpacing: "0.3px",
                                        marginTop: "0.4rem"
       
                                      }} >Quantity: {product.weight}</h5>
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center ">
                    <button
                      className="btn btn-outline-dark ml-3 mr-3 mt-2 mb-2 text-center btn-lg rounded-pill shadow"
                      onClick={(e) => handleAddToCart(e, product)}  // Pass the event object `e` and the product
                    >
                      <IoIosCart /> Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <ToastContainer/>
    </div>
  );
}
